import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import TdsListWidget from '../Widgets/TdsList';

const TdsDashboard = props => (
  <div id="players-dashboard">
    <header className="content-header">
      <h1>
        Gameweek preview
        <small>/ Tour Des Stades</small>
      </h1>
      <ol className="breadcrumb">
        <li>
          <i className="fa fa-wrench" /> Tools
        </li>
        <li className="text-bold">
          <Link to="/tds">Gameweek preview</Link>
        </li>
      </ol>
    </header>
    <section className="content">
      <TdsListWidget />
    </section>
  </div>
);

export default connect(
  () => ({}),
  dispatch => ({dispatch}),
)(TdsDashboard);



// WEBPACK FOOTER //
// ./src/pages/Tools/Tds/Dashboard/index.js